export default __webpack_public_path__ + "static/media/save-your-history.42c318f3.mp3";